<template>
  <v-dialog v-model="dialog" persistent :retain-focus="false">
    <v-card class="py-2 px-5 px-sm-16 px-md-16 px-lg-16 px-xl-16 py-sm-8 py-md-8 py-lg-8 py-xl-8">
      <v-card-title class="headline">
        Campaign Applicant {{ lastName }} {{ firstName }}
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" md="6">
              <v-form>
                <v-text-field label="Last Name" :value="lastName" readonly outlined />
                <v-text-field label="First Name" :value="firstName" readonly outlined />
                <v-text-field label="Email" :value="email" readonly outlined />
                <v-text-field label="Phone" :value="mobilePhone" readonly outlined />
                <v-text-field label="Link" :value="link" readonly outlined />
                <v-text-field
                  label="Multiple Choice Question"
                  :value="multipleChoiceQuestion || '-'"
                  readonly
                  outlined
                />
                <v-text-field
                  label="Multiple Choice Answer"
                  :value="multipleChoiceAnswer || '-'"
                  readonly
                  outlined
                />
              </v-form>
            </v-col>

            <v-col cols="12" md="6">
              <v-form>
                <v-text-field label="Institution" :value="institution" readonly outlined />
                <v-text-field label="Position" :value="position" readonly outlined />
                <v-text-field
                  label="Date Applied"
                  :value="formatDateString(dateApplied)"
                  readonly
                  outlined
                />
                <v-text-field label="Campaign Title" :value="campaignTitle" readonly outlined />
                <v-text-field label="Description" :value="description" readonly outlined />
                <v-text-field
                  label="Free Text Question"
                  :value="freeTextQuestion || '-'"
                  readonly
                  outlined
                />
                <v-text-field
                  label="Free Text Answer"
                  :value="freeTextAnswer || '-'"
                  readonly
                  outlined
                />
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-row justify="end">
          <v-btn depressed rounded large class="custom-button" outlined @click="close">
            {{ $t('close') }}
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import debounce from 'lodash/debounce';

export default {
  name: 'PreviewApplicantDialog',
  props: {
    dialog: Boolean,
    applicant: Object,
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      institution: '',
      position: '',
      dateApplied: '',
      campaignTitle: '',
      mobilePhone: '',
      link: '',
      description: '',
      multipleChoiceQuestion: '',
      freeTextQuestion: '',
      multipleChoiceAnswer: '',
      freeTextAnswer: '',
    };
  },
  watch: {
    dialog(newVal, oldVal) {
      if (newVal && !oldVal && !this.isPreviewFetched) {
        this.debouncedGetPreview();
      }
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    formatDateString(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${day}/${month}/${year}`;
    },
    getCampaignApplicantPreview() {
      if (this.applicant.id && this.applicant.campaignId) {
        const campaignId = this.applicant.campaignId;
        const applicantId = this.applicant.id;

        this.axios
          .get(`/api/v1/campaign/${campaignId}/campaign-applicant/${applicantId}`)
          .then(response => {
            if (response.status === 200) {
              console.log('Applicant preview data:', response.data);
              this.firstName = response.data.firstname || '-';
              this.lastName = response.data.lastname || '-';
              this.email = response.data.email || '-';
              this.institution = response.data.institution || '-';
              this.position = response.data.position || '-';
              this.dateApplied = response.data.dateApplied || '-';
              this.campaignTitle = response.data.campaignTitle || '-';
              this.mobilePhone = response.data.mobilePhone || '-';
              this.link = response.data.link || '-';
              this.description = response.data.description
                ? response.data.description.replace(/<\/?p>/g, '')
                : '-';

              const questions = response.data.campaignApplicantQuestions;
              if (questions && Array.isArray(questions)) {
                questions.forEach(question => {
                  if (question.freeTextAnswer === null) {
                    this.multipleChoiceQuestion = question.campaignQuestion;
                    this.multipleChoiceAnswer = question.campaignAnswer.answer;
                  } else {
                    this.freeTextQuestion = question.campaignQuestion;
                    this.freeTextAnswer = question.freeTextAnswer;
                  }
                });
              }
            }
          })
          .catch(error => {
            console.error('Error fetching applicant preview:', error);
          });
      }
    },
    debouncedGetPreview: debounce(function() {
      this.getCampaignApplicantPreview();
    }),
  },
};
</script>

<style scoped>
.custom-button {
  color: black;
  font-weight: bold;
  margin: 0 2px;
}

.custom-button:hover {
  background: rgba(157, 87, 244, 1);
  color: white;
  font-weight: bold;
}
</style>
